import apiService from "./axiosInstances/interceptConfiguration";
import { PostScheduleDto } from "@/typeDeclarations/Requests/PostScheduleDto";

export const postSchedule = async (scheduleDto: PostScheduleDto) => {
  await apiService.post(`/api/v1/Schedules/`, scheduleDto);
};
